<template>
	<div>
		<b-overlay :show="isLoading">
			<b-row>
				<!-- Card para Peso Máximo de Hembra -->
				<b-col cols="12" md="6">
					<b-card class="p-2" no-body>
						<h3 class="text-uppercase text-center">Peso Máximo de Hembra</h3>
						<p class="text-center text-muted">Define el peso máximo permitido para las hembras</p>
						<b-row>
							<b-col class="my-1" cols="12" md="10" style="margin-left: auto; margin-right: auto">
								<b-form-group label="Peso máximo (kg)">
									<vue-number-input
										center
										vertical
										controls
										v-model="pesoMaximoHembra"
										:min="1"
										:step="1"
									/>
								</b-form-group>
							</b-col>
						</b-row>
						<b-row>
							<b-col class="text-right">
								<b-button
									size="lg"
									variant="success"
									:disabled="isLoading || !hasChangesHembra"
									@click="setConfigHembra"
								>
									Guardar
								</b-button>
							</b-col>
						</b-row>
					</b-card>
				</b-col>

				<!-- Card para Peso Máximo de Macho -->
				<b-col cols="12" md="6">
					<b-card class="p-2" no-body>
						<h3 class="text-uppercase text-center">Peso Máximo de Macho</h3>
						<p class="text-center text-muted">Define el peso máximo permitido para los machos</p>
						<b-row>
							<b-col class="my-1" cols="12" md="10" style="margin-left: auto; margin-right: auto">
								<b-form-group label="Peso máximo (kg)">
									<vue-number-input
										center
										vertical
										controls
										v-model="pesoMaximoMacho"
										:min="1"
										:step="1"
									/>
								</b-form-group>
							</b-col>
						</b-row>
						<b-row>
							<b-col class="text-right">
								<b-button
									size="lg"
									variant="success"
									:disabled="isLoading || !hasChangesMacho"
									@click="setConfigMacho"
								>
									Guardar
								</b-button>
							</b-col>
						</b-row>
					</b-card>
				</b-col>
			</b-row>
		</b-overlay>
	</div>
</template>

<script>
import genderWeightService from "@/views/brain/specimens/views/weights/services/gender-weight.service.js"
export default {
	name: "WeightsView",
	data: () => ({
		isLoading: false,
		pesoMaximoHembra: 1,
		pesoMaximoMacho: 1,
		clearConfig: {
			pesoMaximoHembra: 0,
			pesoMaximoMacho: 0,
		},
	}),
	computed: {
		hasChangesHembra() {
			return this.pesoMaximoHembra != this.clearConfig.pesoMaximoHembra
		},
		hasChangesMacho() {
			return this.pesoMaximoMacho != this.clearConfig.pesoMaximoMacho
		},
	},
	methods: {
		async getConfig() {
			this.isLoading = true
			const { data } = await genderWeightService.getGenderWeights()
			this.pesoMaximoHembra = Number(data.hembra)
			this.pesoMaximoMacho = Number(data.macho)

			this.clearConfig = {
				pesoMaximoHembra: this.pesoMaximoHembra,
				pesoMaximoMacho: this.pesoMaximoMacho,
			}
			this.isLoading = false
		},
		async setConfigHembra() {
			const { isConfirmed } = await this.showConfirmSwal({
				text: "Se actualizará el peso máximo para hembras.",
			})
			if (!isConfirmed) return

			this.isLoading = true
			await genderWeightService.updateGenderWeight({
				gender: "HEMBRA",
				max_weight: this.pesoMaximoHembra,
			})

			this.isLoading = false
			this.getConfig()
			this.showToast("success", "top-right", "Pesos", "CheckIcon", "Peso máximo de hembra guardado exitosamente")
		},
		async setConfigMacho() {
			const { isConfirmed } = await this.showConfirmSwal({
				text: "Se actualizará el peso máximo para machos.",
			})
			if (!isConfirmed) return

			this.isLoading = true

			await genderWeightService.updateGenderWeight({
				gender: "MACHO",
				max_weight: this.pesoMaximoMacho,
			})

			this.isLoading = false
			this.getConfig()
			this.showToast("success", "top-right", "Pesos", "CheckIcon", "Peso máximo de macho guardado exitosamente")
		},
	},
	created() {
		this.getConfig()
	},
}
</script>

<style scoped>
.b-card {
	margin-bottom: 1rem;
}

h3 {
	margin-bottom: 1rem;
}

@media screen and (max-width: 768px) {
	.b-col {
		margin-bottom: 1.5rem;
	}
}
</style>
